module.exports = __webpack_public_path__ + "img/amalan-protect-new.130c3193.svg";